/* eslint-disable */

const INITIAL_STATE = {
  currentUser: {
    id: undefined,
    firstname: '',
    surname: '',
    organization: {},
    street: '',
    number: '',
    zip: '',
    city: '',
    country: '',
    state: '',
    roles: '',
    hasAdminRole: false,
    hasUserAdminRole: false,
    hasAssetAdminRole: false,
    hasAgreementAdminRole: false,
    hasAssetManagerRole: false,
    hasTraderRole: false,
    hasMatcherRole: false,
    active: true,
    address: '',
  },
  localUserPicture: null,
  users: [],
  error: { message: '', isVisible: false },
  loading: false,
  loadingForm: false,
  order: 'asc',
  orderBy: 'id',
  selected: [],
  page: 0,
  rowsPerPage: 10,
  organizationConsumingAssets: []
};

const usersReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case 'GET_USERS_START':

      return { ...state, loading: true, currentUser: INITIAL_STATE }
    case 'GET_USERS_SUCCESS':
      return { ...state, users: action.payload, loading: false }
    case 'GET_USERS_FAIL':

      return { ...state, loading: false }

    case 'GET_USER_START':

      return { ...state, loading: true }
    case 'GET_USER_SUCCESS':

      return { ...state, currentUser: action.payload, loading: false }
    case 'GET_USER_FAIL':

      return { ...state, loading: false }


    case 'GET_USER_FORM_START':

      return { ...state, loadingForm: true }
    case 'GET_USER_FORM_SUCCESS':

      return { ...state, currentUser: action.payload, loadingForm: false, localUserPicture: null }

    case 'ORGANIZATION_CONSUMPTION_ASSETS_CHANGED': 
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          organizationConsumingAssets: action.payload
        }
      }
    case 'FORM_USER_CONSUMING_ASSET_LIST_CHANGED': 
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          user_metadata: {
            ...state.currentUser.user_metadata,
            consumingAssets: action.payload.user_metadata.consumingAssets,
          }
        }
      }

    case 'FORM_USER_CONSUMING_ASSET_LIST_RESET': 
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          user_metadata: {
            ...state.currentUser.user_metadata,
            consumingAssets: [],
          }
        }
      }
    
    case 'GET_USER_FORM_FAIL':

      return { ...state, loadingForm: false }

    case 'ROLES_CHANGED':
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          app_metadata: {
            ...state.currentUser.app_metadata,
            roles: action.payload,
          }
        }
      }



    case 'CREATE_USER_START':

      return { ...state, loading: true, currentUser: INITIAL_STATE }
    case 'CREATE_USER_SUCCESS':

      return { ...state, loading: false }
    case 'CREATE_USER_FAIL':

      return { ...state, loading: false }


    case 'UPDATE_USER_START':

      return { ...state, loading: true }
    case 'UPDATE_USER_SUCCESS':

      return { ...state, loading: false }
    case 'UPDATE_USER_FAIL':

      return { ...state, loading: false }


    case 'FIRSTNAME_CHANGED':

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          firstName: action.payload,
          offchainData: {
            ...state.currentUser.offchainData,
            user_metadata: {
              ...state.currentUser.offchainData.user_metadata,
              firstname: action.payload,
            }
          }
        }
      }

    case 'NAME_CHANGED':

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          user_metadata: {
            ...state.currentUser.user_metadata,
            name: action.payload,
          }
        }
      }
    case 'FIRST_NAME_CHANGED':

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          user_metadata: {
            ...state.currentUser.user_metadata,
            firstname: action.payload,
          }
        }
      }
    case 'LAST_NAME_CHANGED':

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          user_metadata: {
            ...state.currentUser.user_metadata,
            lastname: action.payload,
          }
        }
      }
    case 'USER_NAME_CHANGED':

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          user_metadata: {
            ...state.currentUser.user_metadata,
            username: action.payload,
          }
        }
      }

    case 'PHONE_NUMBER_CHANGED':

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          user_metadata: {
            ...state.currentUser.user_metadata,
            phoneNumber: action.payload,
          }
        }
      }


    case 'SURNAME_CHANGED':

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          surname: action.payload,
          offchainData: {
            ...state.currentUser.offchainData,
            user_metadata: {
              ...state.currentUser.offchainData.user_metadata,
              surname: action.payload,
            }
          }
        }
      }


    case 'ORGANIZATION_CHANGED':

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          user_metadata: {
            ...state.currentUser.user_metadata,
            organization: action.payload
          }
        }
      }
    case 'EMAIL_CHANGED':

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          email: action.payload
        }
      }


    case 'ADDRESS_CHANGED':

      let fullAddress = state.currentUser.number + ' ';
      fullAddress += state.currentUser.street ? state.currentUser.street + ', ' : '';
      fullAddress += state.currentUser.zip ? state.currentUser.zip + ', ' : '';
      fullAddress += state.currentUser.city ? state.currentUser.city + ', ' : '';
      fullAddress += state.currentUser.region ? state.currentUser.region + ', ' : '';
      fullAddress += state.currentUser.country ? state.currentUser.country + ' ' : '';



      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          street: action.payload.street,
          number: action.payload.houseNumber,
          zip: action.payload.zip,
          city: action.payload.city,
          country: action.payload.country,
          region: action.payload.region,
          offchainData: {
            ...state.currentUser.offchainData,
            user_metadata: {
              ...state.currentUser.offchainData.user_metadata,
              street: action.payload.street,
              number: action.payload.houseNumber,
              zip: action.payload.zip,
              city: action.payload.city,
              country: action.payload.country,
              region: action.payload.region
            }
          }
        }
      }

    case "RESET_USER":
      return {
        ...state,
        currentUser: {
          id: undefined,
          firstname: '',
          surname: '',
          organization: {},
          street: '',
          number: '',
          zip: '',
          city: '',
          country: '',
          state: '',
          roles: '',
          hasAdminRole: false,
          hasUserAdminRole: false,
          hasAssetAdminRole: false,
          hasAgreementAdminRole: false,
          hasAssetManagerRole: false,
          hasTraderRole: false,
          hasMatcherRole: false,
          active: true,
          address: '',
        },
        localUserPicture: null,
      };

    case "USER_PICTURE_CHANGED":
      return {
        ...state,
        localUserPicture: action.payload
      };

    case 'TYPE_CHANGED':

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          user_metadata: {
            ...state.currentUser.user_metadata,
            type: action.payload,
          }
        }
      }

    case 'REAL_ACCOUNT_CHANGED':
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          app_metadata: {
            ...state.currentUser.app_metadata,
            realAccount: action.payload,
          }
        }
      }

    case 'ROLES_ADMIN_CHANGED':

      const newHasAdminRole = !state.currentUser.hasAdminRole;
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          hasAdminRole: newHasAdminRole,
          hasUserAdminRole: newHasAdminRole ? true : false,
          hasAssetAdminRole: newHasAdminRole ? true : false,
          hasAgreementAdminRole: newHasAdminRole ? true : false,
          hasAssetManagerRole: newHasAdminRole ? true : false,
          hasTraderRole: newHasAdminRole ? true : false,
          hasMatcherRole: newHasAdminRole ? true : false
        }
      }

    case 'ROLES_USER_ADMIN_CHANGED':

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          hasUserAdminRole: !state.currentUser.hasUserAdminRole
        }
      }

    case 'ROLES_ASSET_ADMIN_CHANGED':

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          hasAssetAdminRole: !state.currentUser.hasAssetAdminRole
        }
      }

    case 'ROLES_AGREEMENT_ADMIN_CHANGED':

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          hasAgreementAdminRole: !state.currentUser.hasAgreementAdminRole
        }
      }

    case 'ROLES_ASSET_MANAGER_CHANGED':

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          hasAssetManagerRole: !state.currentUser.hasAssetManagerRole
        }
      }

    case 'ROLES_TRADER_CHANGED':

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          hasTraderRole: !state.currentUser.hasTraderRole
        }
      }

    case 'ROLES_MATCHER_CHANGED':

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          hasMatcherRole: !state.currentUser.hasMatcherRole
        }
      }


    case 'ACTIVE_USER_CHANGED':

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          active: action.payload
        }
      }

    case "SORT_USERS":
      const users = action.payload.users;
      const order = action.payload.order;
      const orderBy = action.payload.orderBy;
      return { ...state, users, order, orderBy };

    case "CHANGE_PAGE":
      const page = action.payload.page;
      return { ...state, page };

    case "CHANGE_ROWS_PER_PAGE":
      const rowsPerPage = action.payload.rowsPerPage;
      return { ...state, rowsPerPage };

    default:
      return state
  }
}

export default usersReducer



// WEBPACK FOOTER //
// ./src/reducers/usersReducer.js